import React, { useEffect, useRef, useState } from "react";
import inputsValidation from "../../messages/inputValidation";
import "./style.scss";
import { IoIosCloseCircleOutline } from "react-icons/io";
import MaskedInput from "react-text-mask";

interface IProps {
  type: string;
  name: string;
  text: string;
  isLabel?: boolean;
  register: any;
  errors: any;
  defaultValue?: any;
  setValue: any;
}

const InputReactForm: React.FC<IProps> = ({
  name,
  text,
  isLabel = false,
  type,
  register,
  errors,
  defaultValue,
  setValue
}: IProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [value, setValueState] = useState(defaultValue || "");

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    register.onBlur(event);
  };

  useEffect(() => {
    if (containerRef.current) {
      const input = containerRef.current.querySelector("input");
      if (input) {
        setValueState((input as HTMLInputElement).value);
      }
    }
  }, [isFocused]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (type === "number" && !/^\d+$/.test(event.key)) {
      event.preventDefault();
    }
    if (name === "firstName" && !/^[a-zA-Z]+$/.test(event.key)) {
      event.preventDefault();
    }
    if (name === "lastName" && !/^[a-zA-Z-]+$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleClear = () => {
    setValueState("");
    const input = containerRef.current?.querySelector("input");
    if (input) {
      (input as HTMLInputElement).value = "";
      const event = new Event("input", { bubbles: true });
      input.dispatchEvent(event);
    }
    setValue(name, "");
  };

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    if (type === "number" && /\D/.test(event.currentTarget.value)) {
      event.currentTarget.value = event.currentTarget.value.replace(/\D/g, "");
    }
    if (name === "firstName" && /[^a-zA-Z]/.test(event.currentTarget.value)) {
      event.currentTarget.value = event.currentTarget.value.replace(/[^a-zA-Z-]/g, "");
    }
    if (name === "lastName" && /[^a-zA-Z-]/.test(event.currentTarget.value)) {
      event.currentTarget.value = event.currentTarget.value.replace(/[^a-zA-Z-]/g, "");
    }

    setValueState(event.currentTarget.value);
    register.onChange(event);
    setValue(name, event.currentTarget.value);
  };

  const getInputMaskZipCodeOrPhone =
    name === "zipCode" ? [/\d/, /\d/, "-", /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  return (
    <div className={"react-form-input"} id={`input-${name}`} ref={containerRef}>
      <div className={`input-wrapper ${isFocused || value ? "has-focus-or-value" : ""}`} data-placeholder={text}>
        {isLabel && (
          <label className={"label-input"} htmlFor={name}>
            {text}
          </label>
        )}
        {name === "zipCode" || name === "phone" ? (
          <MaskedInput
            mask={getInputMaskZipCodeOrPhone}
            className="form-control"
            placeholder={isFocused ? "" : text}
            {...register}
            guide={false}
            value={value}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleInput}
            render={(ref, props) => (
              <input
                {...props}
                ref={input => {
                  if (input) ref(input);
                  register.ref(input);
                }}
                type={type}
                onKeyPress={handleKeyPress}
              />
            )}
          />
        ) : (
          <input
            type={type}
            placeholder={isFocused ? "" : text}
            {...register}
            defaultValue={defaultValue}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyPress={handleKeyPress}
            onInput={handleInput}
            pattern={type === "number" && name !== "zipCode" ? "\\d*" : undefined}
          />
        )}
        {value && (
          <button type="button" className="clear-button" onClick={handleClear}>
            <IoIosCloseCircleOutline />
          </button>
        )}
      </div>
      {errors[name] && <span className={"red-class"}>*{inputsValidation(errors, name)}</span>}
    </div>
  );
};

export default InputReactForm;
